export default __webpack_public_path__ + "static/premio_home-EC-495f609d0510d400e765e8ae870305f2.png";